export default __webpack_public_path__ + "static/media/logo_inverted.53f3f6ba.png";